<template>
    <p
        id="items-remaining"
        class="d-flex justify-center align-center"
        v-if="show"
    >
        <v-icon color="black" class="pr-2">mdi-emoticon-outline</v-icon>
        あと残り{{ numberOfRemaining }}項目
    </p>

</template>

<script>
export default {
    name: "items-remaining",
    props: {
        show: Boolean,
        numberOfRemaining: Number
    },
}
</script>

<style scoped lang="scss">
#items-remaining {
    width: 200px;
    margin: 0 auto;
    border: 1px solid #999790;
    padding: 10px;
    border-radius: 4px;
    position: fixed;
    left: 0;
    right: 0;
    background-color: #F8F6EC;
    font-weight: bold;
    z-index: 9999;
    height: 60px;
    opacity: 0.9;
    top: 84px;
}
</style>